// src/components/NotificationListener.js
import React, { useEffect, useState,useRef } from 'react';
import audioFile from './audio.wav';
import { var_api } from '../constant';
import axios from 'axios';

const NotificationListener = () => {
  const [audio] = useState(new Audio(audioFile));
  const [lastOrderId, setLastOrderId] = useState(null);
  const lastOrderIdRef = useRef(null); // Mutable ref to hold last order ID

  const [notificationsEnabled, setNotificationsEnabled] = useState(true);
  const [hasClicked, setHasClicked] = useState(true); // To track if the user has clicked anywhere


  const fetchOrders = async () => {
    console.log("fetchOrders is triggered");
    const shopId = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');
    const today = new Date();
    // const formattedDate = `${today.getDate().toString().padStart(2, '0')}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getFullYear()}`;
    try {
      const response = await axios.get(`${var_api}booking-orders/upcoming-order-list/${shopId}`, {
        headers: {
          Authorization:`${token}`
        }
      });
  
      const orders = response.data.data;
      console.log("or", orders);
      const latestOrder = orders[orders.length - 1];
  
      // Check if there is a new order
      if (lastOrderIdRef.current && latestOrder.id !== lastOrderIdRef.current) {
        try {
          await audio.play();
          console.log("Notification sound played");
  
          // Retrieve existing orders from localStorage or initialize an empty array
          const storedOrders = JSON.parse(localStorage.getItem('orders')) || [];
          
          // Add the new order to the array if it doesn’t already exist
          const orderExists = storedOrders.some(order => order.id === latestOrder.id);
          if (!orderExists) {
            storedOrders.push(latestOrder);
            localStorage.setItem('orders', JSON.stringify(storedOrders));
            console.log("Added Order"+storedOrders);
          }
  
        } catch (error) {
          console.warn("Audio play failed", error);
        }
      }
  
      // Update both state and ref for lastOrderId
      if (latestOrder.id !== lastOrderIdRef.current) {
        setLastOrderId(latestOrder.id);
        lastOrderIdRef.current = latestOrder.id; // Update ref value immediately
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  };
  
    // Log the updated lastOrderId whenever it changes
    useEffect(() => {
      if (lastOrderId !== null) {
        console.log("Updated Last Order ID:", lastOrderId);
      }
    }, [lastOrderId]);
  

  useEffect(() => {
    const intervalId = setInterval(() => {
      const savedNotificationState = localStorage.getItem('notificationsEnabled');
      if (savedNotificationState !== null) {
        const isEnabled = JSON.parse(savedNotificationState);
        if (isEnabled !== notificationsEnabled) {
          setNotificationsEnabled(isEnabled);  // Update state if it differs from current state
          console.log(isEnabled)
        }
      }
    }, 1000); // Check every 5 seconds

    return () => {
      clearInterval(intervalId);  // Clean up the interval on unmount
    };
  }, [notificationsEnabled]); // Run this effect whenever `notificationsEnabled` changes

 // useEffect to start the interval once the user clicks anywhere
 useEffect(() => {
    const handleClick = () => {
      setHasClicked(true); // Set to true when user clicks anywhere
    };

    // Add the click event listener to the document
    document.addEventListener('click', handleClick);

    // Cleanup function to remove the click event listener
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []); // Empty dependency array so it only runs on component mount and unmount

  // useEffect to handle the interval logic based on notificationsEnabled and hasClicked
  useEffect(() => {
    const shopId = localStorage.getItem('ShopId');
    if (notificationsEnabled && hasClicked) {
      console.log("Interval is set for fetchOrders");
      console.log("notificationsEnabled:", notificationsEnabled);
console.log("hasClicked:", hasClicked);
      const intervalId = setInterval(fetchOrders, 2000); // Start interval when notifications are enabled and user has clicked
      console.log("APIk Endpoint:", `${var_api}booking-orders/upcoming-order-list/${shopId}`);
      // Cleanup the interval when the component is unmounted or notifications are disabled
      return () => clearInterval(intervalId);
    }
  }, [notificationsEnabled, hasClicked]); // This useEffect is triggered when either notificationsEnabled or hasClicked changes

  return null; // This component does not render any visible UI
};

export default NotificationListener;
